import React, { createContext } from 'react'

export const GeneralContext = createContext({
  options: null,
  page: null
})

const GeneralProvider = ({
  brand,
  options,
  page,
  menus,
  children
}) => (
  <GeneralContext.Provider
    value={{
      brand,
      options,
      page,
      menus,
    }}
  >
    {children}
  </GeneralContext.Provider>
)

export default GeneralProvider
